// extracted by mini-css-extract-plugin
export default {"wrapper":"events_wrapper__LkCPs"};